import React, {useState} from 'react';
import SmartDialog from "../../../../components/SmartDialog";
import {Form, Formik} from "formik";
import * as Yup from 'yup';
import {Badge, Button, UncontrolledTooltip} from "reactstrap";
import {Async as AsyncSelect, components} from "react-select";
import {PaymentsEndpoints, TractorOwnerEndpoints, WalletEndpoints} from "../../../../common/ProxyEndpoints";
import ThreeLineItemRender from "../../../../components/Elements/ThreeLineItemRender";
import StandardValue from "../../../../common/StandardValue";
import MDProgress from 'react-md-progress-bar';
import DataList from "../../../../components/TableListView/DataList";
import TTLProxy from "../../../../common/TTLAsyncProxy";
import Utils from "../../../../common/Utils";
import {css} from "glamor";
import {ExpanderView, SectionedList} from "../../../../components/AuditExplorer/Elements";
import CurrencyLabel from "../../../../components/CurrencyLabel/CurrencyLabel";
import HTML from '../../../../common/HtmlHelpers';
import Icon from 'react-icons-kit';
import {ic_account_balance_wallet} from 'react-icons-kit/md/ic_account_balance_wallet';
import {CustomFilterFrame} from "../../../../components/CRUDView";
import WalletManagement from "../../../../components/WalletManagement/WalletManagement";
import PermissionRender from "../../../../components/PermissionRender/PermissionRender";
import {Permissions} from "../../../../common/Constants";
import TimeAgo from "../../../../common/TimeAgo";
import _ from 'lodash';
import PropTypes from 'prop-types';

const requestRow = css({
    cursor: 'pointer'
});

const selectedRequestRow = css({
    backgroundColor: "#e2e2e2",
    borderLeft: "solid 4px #00b652",
    '&:hover': {
        backgroundColor: 'rgba(185,185,185,0.2)'
    }
});

const ValidationSchema = Yup.object().shape({
    owner: Yup.mixed().required().label("Tractor owner"),
    wallet: Yup.mixed().required().label("Wallet"),
    selectedRequests: Yup.array(),
    payableRequests: Yup.array(),
    paymentResult: Yup.mixed()
});

const requestLabel = (request) => ({ label: `#${request.order_id} - ${request.service.name} (${request.hectares} ${Utils.pluralize(request.hectares,"hectare")})` , value: request.id  , instance: request });
const ownerLabel = (owner) => ({ label: owner.name , value: owner.id  , instance: owner });
const walletLabel = (wallet) => ({ label: `${wallet.name} (${wallet.provider.toUpperCase()})` , value: wallet.id, instance: wallet });

const TransferStatus = {
    Success: "success",
    Failed: "fail"
};

const PaymentStatusList = ({ results , listRef }) => {

    return <div>

        <div className="clearfix">

            <h6 className="pull-left"><i className="fa fa-archive"/> Payment Results</h6>

            <div className="pull-right">
                <Badge pill={true} color="success">Successful : <b>{results.filter(x => x.status === TransferStatus.Success).length}</b></Badge>
                <Badge pill={true} color="danger">Failed: <b>{results.filter(x => x.status === TransferStatus.Failed).length}</b></Badge>
            </div>

        </div>

        <DataList data={results}
                  listRef={listRef}
                  defaultRowClass={`${requestRow}`}
                  itemsPerPage={5}
                  columns={[
                      {
                          key: "request",
                          label: "Request",
                          render: item => {

                              const id = `popover-result-request-info-${item.request.id}`;
                              return <React.Fragment>

                                  <span id={id}>{item.request.order_id}</span>

                                  <UncontrolledTooltip target={id} placement={"bottom"} fade={false}>

                                      <div className="text-left">
                                          <p><b>Service: </b> {item.request.service.name}</p>
                                          <p><b>Location: </b> {item.request.location}</p>
                                          <p><b>Tractor: </b> {item.request.tractor.name} ({item.request.tractor.registration_number})</p>
                                          <p><b>Operator: </b> {item.request.tractor_operator.name}</p>
                                      </div>

                                  </UncontrolledTooltip>

                              </React.Fragment>

                          }
                      },
                      {
                          key: "amount",
                          label: <span><i className="fa fa-money"/> Transfer Amount</span>,
                          render: item => {
                              return <CurrencyLabel value={item.amount} currency={item.request.txn_currency}/>
                          }
                      },
                      {
                          key: "status",
                          label: "Status",
                          render: item => {

                              let content;
                              switch (item.status) {
                                  case TransferStatus.Success:
                                      content = <Badge color={"success"} pill>Successful</Badge>;
                                      break;
                                  case TransferStatus.Failed:
                                      content = <Badge color={"danger"} pill>Failed</Badge>;
                                      break;
                              }

                              return <h6>{content || null}</h6>
                          }
                      }
                  ]}/>

    </div>;
};

const ConfirmationDialog = ({ requests , owner , wallet , dlgRef , isBusy , onConfirm ,listRef }) => {

    const [isConfirmed,setConfirmed] = useState(false);

    return <SmartDialog title={"Confirm Payment?"} ref={dlgRef} onExit={() => setConfirmed(false)}>

        {owner && <CustomFilterFrame>
            <h6>{owner.name}</h6>
            <div>Phone: {owner.user.phone}</div>
            <div>Email: <StandardValue value={owner.user.email}/></div>

            {wallet && <ExpanderView title={<span style={{ display: "inline" }}><Icon icon={ic_account_balance_wallet}/> Wallet</span>}>
                <SectionedList items={[
                    {
                        title: "Name",
                        value: wallet.name
                    },
                    {
                        title: "Provider",
                        value: wallet.provider
                    },
                    {
                        title: "Value",
                        value: wallet.value
                    }
                ]}/>
            </ExpanderView>}

        </CustomFilterFrame>}

        <div className="p-1" style={{ backgroundColor: "#e8e8e8" }}>
            <label><input type="checkbox" checked={isConfirmed} onChange={(evt) => {setConfirmed(evt.target.checked);}}/> I acknowledge payment of this tractor owner</label>
        </div>

        <DataList data={requests}
                  listRef={listRef}
                  defaultRowClass={`${requestRow}`}
                  itemsPerPage={5}
                  columns={[
                      {
                          key: "request",
                          label: "Request",
                          render: item => {

                              const id = `popover-confirm-request-info-${item.request.id}`;
                              return <React.Fragment>
                                  <span id={id}>{item.request.order_id}</span>
                                  <UncontrolledTooltip target={id} placement={"bottom"} fade={false}>

                                      <div className="text-left">
                                          <p><b>Service: </b> {item.request.service.name}</p>
                                          <p><b>Location: </b> {item.request.location}</p>
                                          <p><b>Tractor: </b> {item.request.tractor.name} ({item.request.tractor.registration_number})</p>
                                          <p><b>Operator: </b> {item.request.tractor_operator.name}</p>
                                      </div>

                                  </UncontrolledTooltip>
                              </React.Fragment>

                          }
                      },
                      {
                          key: "amount",
                          label: "Amount",
                          render: item => {
                              return <CurrencyLabel value={item.hasOwnProperty('$payAmount') ? item.$payAmount : item.allowedAmount } currency={item.request.txn_currency}/>
                          }
                      },
                      {
                          key: "remaining",
                          label: "Due (Remaining)",
                          render: item => {
                              return <CurrencyLabel value={ item.allowedAmount - (item.hasOwnProperty('$payAmount') ? item.$payAmount : item.allowedAmount) } currency={item.request.txn_currency}/>
                          }
                      }
                  ]}/>

        {isBusy && <MDProgress show/>}

        <hr/>

        <Button color={"green"} block disabled={!isConfirmed || isBusy} onClick={() => {

            if(window.confirm(`Confirm payment of ${requests.length} request(s) to ${owner.name}`))
                onConfirm();

        }}><i className="fa fa-check"/> Confirm Payment</Button>

    </SmartDialog>
};

class MakePaymentDialog extends  React.Component {

    static propTypes = {
        onExit: PropTypes.func
    };

    constructor(props){
        super(props);
        this.state  = MakePaymentDialog.getInitialState({});
        this.proxy = TTLProxy.getInstance();
        this.onSubmitPayment = this.onSubmitPayment.bind(this);
    }

    static getInitialState(values){

        return {
            isBusy: false,
            isSubmitting: false,
            owner: values.owner ? ownerLabel(values.owner) : null,
            wallet: values.wallet ? walletLabel(values.wallet) : null
        };

    }

    show(initialValues = {}){

        this.setState(MakePaymentDialog.getInitialState(initialValues), () => {
            this._dlg.show()
        });

    }

    async fetchOwnerPayableRequests(ownerId, setFieldValue ){

        const requests = (await this.proxy.processRequest(PaymentsEndpoints.getOwnerRequests(ownerId))).getPayload();
        setFieldValue('payableRequests',requests);
        return requests;

    }

    async onSubmitPayment({ selectedRequests: requests ,...values}){

        this.setState({
            isSubmitting: true
        });

        try{

            const payload = requests.map(r => ({
                owner_id: values.owner.value,
                request_id: r.request.id,
                wallet_id: values.wallet.value,
                comments:  values.comment || "",
                amount: Number(r.hasOwnProperty('$payAmount') ? r['$payAmount'] : r.allowedAmount),
                currency: r.request.txn_currency
            }));

            const res = await this.proxy.processRequest( PaymentsEndpoints.makeBulkPayments(payload) );
            if(res.ok){

                let payload = res.getPayload();
                payload.forEach(r => {
                    r.request = requests[r.order].request;
                });

                return payload;

            }

        }
        catch (e) {
            HTML.toastError(Utils.getResponseError(e));
        }
        finally {

            this.setState({
                isSubmitting: false
            });

        }

    }

    render() {

        return <SmartDialog title={<span><i className="fa fa-money"/> Tractor Owner Payments</span>}
                            ref={r => this._dlg = r}
                            large
                            onExit={() => {

                                if(this.props.onExit){
                                    this.props.onExit(this._form ? this._form.getFormikContext().values.paymentResult : undefined);
                                }

                            }}>

            <Formik validationSchema={ValidationSchema}
                    ref={r => this._form = r}
                    initialValues={{
                        owner: this.state.owner,
                        wallet: this.state.wallet,
                        selectedRequests: [],
                        payableRequests: []
                    }}
                    onSubmit={async (values,{ setSubmitting }) => {
                        this._confirmPayment.show();
                        setSubmitting(false);
                    }}>
                {({ isValid , setFieldValue , values  }) => {

                    return <Form className="p-5">

                            {values.paymentResult ? <PaymentStatusList listRef={r => this._paymentStatusList = r}
                                                                       results={values.paymentResult}/> : <React.Fragment>

                                <CustomFilterFrame>
                                    {(!values.owner && !values.wallet && values.selectedRequests.length === 0) && <h6>Welcome to tractor owner payments. To begin, select tractor service provider</h6>}
                                    {(values.owner && !values.wallet) && <h6>Select or configure payment wallet</h6>}
                                    {(values.owner && values.wallet && values.selectedRequests.length === 0) && <h6>Check payable requests to issue payments</h6>}
                                    {(values.owner && values.wallet && values.selectedRequests.length > 0) && <h6>Click on Make Payments button to confirm selection</h6>}
                                </CustomFilterFrame>

                                <div>
                                    <b className="mb-2"><i className="fa fa-user"/> Tractor Owner</b>
                                </div>

                                <AsyncSelect  name="owner"
                                              defaultOptions
                                              cacheOptions
                                              placeholder="Select tractor owner..."
                                              value={values['owner']}
                                              onChange={async value => {

                                                  //    set field value
                                                  setFieldValue('owner',value);
                                                  setFieldValue('wallet',null);
                                                  setFieldValue('selectedRequests',[]);
                                                  setFieldValue('payableRequests',[]);

                                                  //    load payable requests
                                                  await Promise.all([
                                                      this.fetchOwnerPayableRequests(value.value,setFieldValue)
                                                  ]);

                                                  if(this._list){
                                                      this._list.refresh();
                                                  }

                                              }}
                                              components={{
                                                  Option: ({ children , ...props }) => {

                                                      const owner = props.data.instance;
                                                      return <components.Option {...props}>

                                                          <ThreeLineItemRender  media={owner.media}
                                                                                line1Value={owner.name}
                                                                                line2Prefix="Phone"
                                                                                line2Value={owner.user.phone}
                                                                                line3Prefix={"Email"}
                                                                                line3Value={<StandardValue value={owner.user.email}/>}/>

                                                      </components.Option>

                                                  }
                                              }}
                                              loadOptions={async (value) => {

                                                  try {

                                                      const res = await this.proxy.processRequest(TractorOwnerEndpoints.getUrl(), {
                                                          search: { keyword: value , method: 'inside', fields: ['name' , 'user.email', 'user.phone' ] },
                                                          pagination: { page: 1 , perPage : 5 },
                                                          include: [ 'media' , 'user' ]
                                                      });

                                                      return res.getPayload().map(t => ownerLabel(t));
                                                  }
                                                  catch (e) {

                                                      // failed to load query

                                                  }

                                              }}/>

                                <br/>

                                {values.owner && <React.Fragment>

                                    <div className="clearfix">

                                        <b className="pull-left"><Icon icon={ic_account_balance_wallet}/> Wallet</b>

                                        <PermissionRender required={[ Permissions.Wallet.Manage ]}>
                                            <div className="pull-right">
                                                <Button color="link" size="sm" onClick={() => this._walletManagementDlg.show(values.owner.instance.user)}><i className="fa fa-edit"/> Manage Wallets</Button>
                                            </div>
                                        </PermissionRender>

                                    </div>

                                    <AsyncSelect name="wallet"
                                                 defaultOptions
                                                 cacheOptions
                                                 placeholder="Select payment wallet..."
                                                 value={values['wallet']}
                                                 onChange={value => {
                                                     setFieldValue('wallet',value);
                                                 }}
                                                 components={{
                                                     Option: ({ children , ...props }) => {

                                                         const wallet = props.data.instance;
                                                         return <components.Option {...props}>

                                                             <ThreeLineItemRender  line1Value={wallet.name}
                                                                                   line2Prefix="Provider"
                                                                                   line2Value={<span>{wallet.provider}  {wallet.is_default && <Badge pill>Default</Badge>}</span>}
                                                                                   line3Prefix={"Value"}
                                                                                   line3Value={wallet.value}/>

                                                         </components.Option>

                                                     }
                                                 }}
                                                 loadOptions={async (value) => {

                                                     if(!values.owner){
                                                         return [];
                                                     }

                                                     try {

                                                         const res = await this.proxy.processRequest(WalletEndpoints.getWalletsForUser(values.owner.instance.user.id).url, {
                                                             search: { keyword: value , method: 'inside', fields: ['name', 'provider' , 'value' ] },
                                                             pagination: { page: 1 , perPage : 5 },
                                                             filter: [
                                                                 { key: "enabled" , operator: "=" , value: "1" }
                                                             ]
                                                         });

                                                         return res.getPayload().map(t => walletLabel(t));
                                                     }
                                                     catch (e) {

                                                         // failed to load query

                                                     }

                                                 }}/>

                                </React.Fragment>}

                                {values.owner && values.wallet && <React.Fragment>
                                    <DataList listRef={r => this._list = r}
                                              itemsPerPage={5}
                                              responsive
                                              defaultRowClass={`${requestRow}`}
                                              columns={[
                                                  {
                                                      key: "_select",
                                                      render: (item) => {

                                                          return <span>
                                                          <input type="checkbox" title="Check to make payment" checked={values.selectedRequests.includes(item)} onChange={evt => {

                                                              const checked = evt.target.checked;

                                                              let selected;
                                                              if(checked)
                                                                  selected = values.selectedRequests.concat([ item ]);
                                                              else {
                                                                  values.selectedRequests.splice( values.selectedRequests.indexOf(item) , 1 );
                                                                  selected = values.selectedRequests;
                                                              }

                                                              setFieldValue('selectedRequests', selected);

                                                              if(this._confirmListRef)
                                                                  this._confirmListRef.refresh();

                                                          }}/>
                                                      </span>
                                                      }
                                                  },
                                                  {
                                                      key: "order_id",
                                                      label: "ID",
                                                      render: item => {

                                                          const id = `popover-request-info-${item.request.id}`;
                                                          return <React.Fragment>
                                                              <span id={id}>{item.request.order_id}</span>
                                                              <UncontrolledTooltip target={id} placement={"bottom"} fade={false}>

                                                                  <div className="text-left">
                                                                      <p><b>Service: </b> {item.request.service.name}</p>
                                                                      <p><b>Location: </b> {item.request.location}</p>
                                                                      <p><b>Tractor: </b> {item.request.tractor.name} ({item.request.tractor.registration_number})</p>
                                                                      <p><b>Operator: </b> {item.request.tractor_operator.name}</p>
                                                                  </div>

                                                              </UncontrolledTooltip>
                                                          </React.Fragment>

                                                      }
                                                  },
                                                  {
                                                      key: "cost",
                                                      label: "Cost",
                                                      render: item => {

                                                          const id = `popover-request-cost-${item.request.id}`;

                                                          return <React.Fragment>

                                                              <CurrencyLabel id={id} value={item.request.cost} currency={item.request.txn_currency}/>

                                                              <UncontrolledTooltip target={id} placement={"bottom"} fade={false}>

                                                                  <div className="text-left">
                                                                      <p><b>Commission: </b> <CurrencyLabel value={item.request.commission} currency={item.request.txn_currency}/> ({item.commissionPercentage}%)</p>
                                                                      <p><b>Payout Amount: </b> <CurrencyLabel value={item.request.payout} currency={item.request.txn_currency}/> ({item.payoutPercentage}%)</p>
                                                                  </div>

                                                              </UncontrolledTooltip>
                                                          </React.Fragment>

                                                      }
                                                  },
                                                  {
                                                      key: "date_completed",
                                                      label: "Completed",
                                                      render: item => item.request.date_completed ? <TimeAgo id={`completed-${item.request.id}`} date={item.request.date_completed}/> : null
                                                  },
                                                  {
                                                      key: "amount",
                                                      label: <span><i className="fa fa-money"/> Amount</span>,
                                                      render: item => {

                                                          return <span>

                                                          <input className="form-control form-input-select"
                                                                 min={Math.min(1,item.allowedAmount)}
                                                                 max={item.allowedAmount}
                                                                 value={item.hasOwnProperty('$payAmount') ? item['$payAmount'] : item.allowedAmount}
                                                                 onChange={evt => {

                                                                     const value = evt.target.value;
                                                                     const low = Math.min(1,item.allowedAmount);

                                                                     let amount;
                                                                     if(_.isNil(value) || (value.toString().trim() === "")){
                                                                         amount = low;
                                                                     }
                                                                     else{

                                                                         amount = Number(value);
                                                                         if(amount > item.allowedAmount){
                                                                             amount = item.allowedAmount;
                                                                         }
                                                                         else if(amount < low){
                                                                             amount = low;
                                                                         }
                                                                     }

                                                                     item['$payAmount'] = amount;
                                                                     setFieldValue('payableRequests',values.payableRequests);

                                                                 }}
                                                                 type="number"/>

                                                      </span>
                                                      }
                                                  }
                                              ]}
                                              getRowClass={item => values.selectedRequests.includes(item) ? `${selectedRequestRow}` : ""}
                                              queryData={async (page,limit,{ paginate }) => {

                                                  const requests = (values.payableRequests || await this.fetchOwnerPayableRequests(values.owner.value,setFieldValue)) || [];

                                                  return {
                                                      items: paginate(requests,page,limit),
                                                      count: requests.length
                                                  };

                                              }}
                                              noRowsMessage={"No outstanding payable requests available (:-"}/>
                                </React.Fragment> }


                                <hr/>

                                <Button color="green" block disabled={!isValid || values.selectedRequests.length === 0}>
                                    <i className="fa fa-money"/> Make Payments
                                </Button>

                                <WalletManagement ref={r => this._walletManagementDlg = r} colCount={3}/>

                                <ConfirmationDialog dlgRef={r => this._confirmPayment = r}
                                                    listRef={r => this._confirmListRef = r}
                                                    isBusy={this.state.isSubmitting}
                                                    owner={values.owner ? values.owner.instance : null}
                                                    wallet={values.wallet ? values.wallet.instance : null}
                                                    requests={values.selectedRequests}
                                                    onConfirm={async () => {

                                                        //  submit
                                                        const data = await this.onSubmitPayment(values);
                                                        if(!_.isNil(data)){

                                                            //  hide
                                                            this._confirmPayment.hide();

                                                            //  show payment status
                                                            setFieldValue('paymentResult',data);
                                                        }


                                                    }} />

                            </React.Fragment>}


                    </Form>
                }}
            </Formik>


        </SmartDialog>

    }

}

export default MakePaymentDialog;


// WEBPACK FOOTER //
// ./src/views/Extras/Finance/TractorOwnerPayouts/MakePaymentDialog.js